import { saveData, getData } from "../helpers/recentlyViewed";

class RecentlyViewedSearchProducts extends HTMLElement {
  constructor() {
    super();
    this.recentlyViewedItems = getData();
    this.itemContainer = this.querySelector("[data-item-container]");

    if (!this.recentlyViewedItems.length) return;

    this.classList.add("active");
    this.itemContainer.innerHTML = this.recentlyViewedItems
      .map((item) => item.searchProductCardMarkup)
      .join("");
  }
}

if (!customElements.get("recently-viewed-search-products")) {
  customElements.define(
    "recently-viewed-search-products",
    RecentlyViewedSearchProducts,
  );
}
